import { Route, Routes } from 'react-router'
import CodePage from '../pages/codePage'
import DevicePage from '../pages/devicePage'
import PasscodeChecker from '../pages/devicePage/PasscodeChecker'
import { useOfflineToast } from '../hooks/useOfflineToast'

const appRoutes = () => {
  useOfflineToast()
  return (
    <Routes>
      <Route path="code/:appId" element={<CodePage />} />
      <Route
        path="device/:guid"
        element={
          <PasscodeChecker>
            <DevicePage />
          </PasscodeChecker>
        }
      />
    </Routes>
  )
}

export default appRoutes

export const ROUTE_PATHS = {
  ROOT: '/',
  CODE: '/code/:appId',
  DEVICE: '/device/:guid'
}
